import { Part, PartTypeSchema } from "shared";

export const getCanDisplayReliableChip = ({
  isFetchedQuoteRequestLine,
  isAssemblyParent,
  part,
}: {
  isFetchedQuoteRequestLine: boolean;
  isAssemblyParent: boolean;
  part: Pick<Part, "hasTopologicalEmbedding" | "hasDrawingEmbedding" | "type"> | undefined;
}) => {
  return (
    isFetchedQuoteRequestLine &&
    !isAssemblyParent &&
    (!!part?.hasTopologicalEmbedding || !!part?.hasDrawingEmbedding) &&
    part.type !== PartTypeSchema.enum.CONSUMABLE
  );
};
